module.exports = __webpack_public_path__ + "cc643863ebfd293f70b09380dddf348f.svg";